import React from 'react';
import { KANBAN_COLUMNS, STATUS_CONFIG, TASKS_PER_PAGE } from './taskConfigs';
import { TaskCard } from './TaskCard';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const KanbanBoard = ({ tasks, kanbanPages, setKanbanPages, draggedTask, handleKanbanDrop, taskCardProps }) => {
  const grouped = {};
  KANBAN_COLUMNS.forEach(s => { grouped[s] = []; });
  tasks.forEach(t => {
    const col = KANBAN_COLUMNS.includes(t.status) ? t.status : 'pending';
    grouped[col].push(t);
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="kanban-board">
      {KANBAN_COLUMNS.map(status => {
        const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
        const StatusIcon = cfg.icon;
        const colTasks = grouped[status];
        const colPage = kanbanPages[status] || 1;
        const totalPages = Math.ceil(colTasks.length / TASKS_PER_PAGE);
        const paged = colTasks.slice((colPage - 1) * TASKS_PER_PAGE, colPage * TASKS_PER_PAGE);
        return (
          <div
            key={status}
            className={`rounded-2xl border-2 border-dashed ${draggedTask ? 'border-amber-300' : 'border-gray-200'} min-h-[300px] flex flex-col`}
            data-testid={`kanban-col-${status}`}
            onDragOver={e => e.preventDefault()}
            onDrop={() => { if (draggedTask && draggedTask.status !== status) handleKanbanDrop(draggedTask.id, status); }}
          >
            <div className={`${cfg.headerBg} ${cfg.headerText} rounded-t-xl px-4 py-2.5 flex items-center justify-between`}>
              <div className="flex items-center gap-2">
                <StatusIcon className="w-4 h-4" />
                <span className="font-semibold text-sm">{cfg.label}</span>
              </div>
              <span className="text-xs font-bold bg-white/60 px-2 py-0.5 rounded-full">{colTasks.length}</span>
            </div>
            <div className="flex-1 p-2 space-y-2 overflow-y-auto">
              {colTasks.length === 0 ? (
                <div className="text-center py-8 text-gray-300 text-xs">Drop tasks here</div>
              ) : (
                paged.map(t => <TaskCard key={t.id} task={t} compact {...taskCardProps} />)
              )}
            </div>
            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-2 py-2 border-t bg-gray-50 rounded-b-xl">
                <button disabled={colPage <= 1} onClick={() => setKanbanPages(p => ({ ...p, [status]: colPage - 1 }))} className="px-1.5 py-0.5 text-[10px] bg-white border rounded disabled:opacity-30"><ChevronLeft className="w-3 h-3" /></button>
                <span className="text-[10px] text-gray-500">{colPage}/{totalPages}</span>
                <button disabled={colPage >= totalPages} onClick={() => setKanbanPages(p => ({ ...p, [status]: colPage + 1 }))} className="px-1.5 py-0.5 text-[10px] bg-white border rounded disabled:opacity-30"><ChevronRight className="w-3 h-3" /></button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
